if (!customElements.get('ir-article')) {
  class IrArticle extends HTMLElement {
    connectedCallback() {
      if (this.dataset.irInitialized === 'true') return;
      this.dataset.irInitialized = 'true';

      this.shareBtn    = this.querySelector('[data-ir-share]');
      this.downloadBtn = this.querySelector('[data-ir-download]');
      this.content     = this.querySelector('[data-ir-content]');

      this.onShareClick    = this.onShareClick.bind(this);
      this.onDownloadClick = this.onDownloadClick.bind(this);

      if (this.shareBtn) {
        this.shareBtn.addEventListener('click', this.onShareClick);
      }

      if (this.downloadBtn) {
        this.downloadBtn.addEventListener('click', this.onDownloadClick);
      }
    }

    disconnectedCallback() {
      if (this.shareBtn) {
        this.shareBtn.removeEventListener('click', this.onShareClick);
      }

      if (this.downloadBtn) {
        this.downloadBtn.removeEventListener('click', this.onDownloadClick);
      }

      delete this.dataset.irInitialized;
    }

    onShareClick() {
      const url = window.location.href;
      const title = document.title;

      if (navigator.share) {
        navigator.share({ title, url }).catch(() => {});
        return;
      }

      if (navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(url).then(() => {
          this.shareBtn.classList.add('is-copied');

          setTimeout(() => {
            this.shareBtn.classList.remove('is-copied');
          }, 1500);
        });
      }
    }

    onDownloadClick() {
      const source = this.querySelector('[data-ir-content]');
      if (!source) return;
    
      const clone = source.cloneNode(true);
      clone.classList.add('ir-pdf');
      const wrapper = document.createElement('div');
      wrapper.className = 'ir-pdf-wrapper';
      wrapper.style.background = '#fff';
      wrapper.appendChild(clone);
      document.body.appendChild(wrapper);
      const style = document.createElement('style');
      style.dataset.irPdf = 'true';
      style.textContent = `
      .ir-pdf .ir-article__content {
        max-width: 100%;
        margin: 0;
        padding: 0 48px 120px;
      }
    
      .ir-pdf p,
      .ir-pdf h1,
      .ir-pdf h2,
      .ir-pdf h3,
      .ir-pdf strong {
        max-width: 720px;
        margin-left: auto;
        margin-right: auto;
      }
    
      .ir-article__image img {
        width: 100%;
        max-width: 100%;
        object-fit: contain;
        height: auto;
        display: block;
        page-break-inside: avoid;
        break-inside: avoid;
      }

      .ir-pdf p {
       
      }
    
      .ir-pdf h1,
      .ir-pdf h2,
      .ir-pdf h3 {
        page-break-after: avoid;
        break-after: avoid;
      }
    
      .ir-pdf table,
      .ir-pdf .ir-article__block {
        page-break-inside: avoid;
        break-inside: avoid;
      }

      @media (max-width: 767px) {
        .ir-pdf .ir-article__image {
          margin: 0 auto 32px;
          padding: 0;
        }

        .ir-pdf .ir-article__image img {
          width: 2480px;
          max-width: 2480px;
          height: auto;
          object-fit: contain;
          display: block;
          margin: 0 auto;
        }
      }

    `;
      document.head.appendChild(style);
        html2pdf()
        .set({
          margin: 0,
          filename: 'article.pdf',
          html2canvas: {
            scale: 2,
            useCORS: true,
            backgroundColor: '#ffffff'
          },
          jsPDF: {
            unit: 'mm',
            format: 'a4',
            orientation: 'portrait'
          }
        })
        .from(wrapper)
        .save()
        .then(() => {
          document.body.removeChild(wrapper);
          document.head.removeChild(style);
        });
    }

    loadScript(src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }
  }

  customElements.define('ir-article', IrArticle);
}
